import script from "./TheAppConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./TheAppConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./TheAppConfiguration.vue?vue&type=style&index=0&id=80e8f914&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80e8f914"]])

export default __exports__